<template>
  <div>
    <!-- <h1>Tabela de ocorrências de/para</h1>
    <br />-->
    <h1>Entregas</h1>

    <b-row>
      <b-table
        ref="selectableTable"
        id="table-tabela-proceda"
        hover
        :busy.sync="tableIsBusy"
        :items="myProvider"
        :fields="fieldsTabelaProceda"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(id)="data">
          <router-link :to="'/entregaOcorrencia/list/' + data.value">{{ data.value }}</router-link>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            @click="row.toggleDetails"
          >{{ row.detailsShowing ? $t("geral.ocultarDetalhes") : $t("geral.exibirDetalhes") }}</b-button>
        </template>
        <template v-slot:row-details="row">
          <!-- <h1>teste {{ row.item['id'] }}</h1> -->
          <div id="div-ocorrencias">
            <b-card title="Detalhes da entrega">
              <timeline :id="row.item['id'].toString()"></timeline>
              <h3>Ocorrências</h3>
              <entrega-ocorrencias :id="row.item['id'].toString()"></entrega-ocorrencias>
            </b-card>
          </div>
          <!-- 
          <div id="div-ocorrencias">
            <b-card>
              <ul>
                <li>
                  <entrega-ocorrencias :id="row.item['id'].toString()"></entrega-ocorrencias>
                </li>
              </ul>
            </b-card>
          </div>-->
          <!-- <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
            </ul>
          </b-card>-->
        </template>
      </b-table>
    </b-row>

    <b-row>
      <b-col sm="4" md="4" lg="4">
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <label
          for="tablePerPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{tableRowCount}}</label>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-row>
          <b-col sm="3" md="3" lg="3">
            <b-form-select
              v-model="tablePerPage"
              id="tablePerPageSelect"
              size="sm"
              :options="tablePageOptions"
            ></b-form-select>
          </b-col>
          <b-col style="padding-left: 0px;">
            <label for="tablePerPageSelect">registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <p>
      Selected Rows:
      <br />
      {{ tableSelectedItem }}
    </p>-->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
// import entregaOcorrencia from "./components/entrega/List.vue";
import entregaOcorrencia from "./ListOcorrencias.vue";
import Timeline from "@/pages/Entregas/TimeLine.vue";

export default {
  name: "List",
  components: {
    "entrega-ocorrencias": entregaOcorrencia,
    Timeline,
  },
  data: function () {
    return {
      fieldsTabelaProceda: [
        {
          key: "actions",
          label: "",
        },
        // {
        //   label: "Actions",
        //   key: "id",
        //   sortable: true,
        // },
        {
          label: "NF-e",
          key: "numero",
          sortable: true,
        },
        {
          label: "Série NF-e",
          key: "serie",
          sortable: true,
        },
        {
          label: "Remetente",
          key: "embarcador.razaoSocial",
          sortable: true,
        },
        {
          label: "Destinatário",
          key: "destinatario.razaoSocial",
          sortable: true,
        },
        // {
        //   label: "Transportador",
        //   key: "transportador.razaoSocial",
        //   sortable: true,
        // },
        // {
        //   label: "Data de emissão",
        //   key: "dataEmissao",
        //   sortable: true,
        // },
        // {
        //   label: "Valor total da NF-e",
        //   key: "valorTotal",
        //   sortable: true,
        // },
        // {
        //   label: "Peso bruto",
        //   key: "pesoBruto",
        //   sortable: true,
        // },
        // {
        //   label: "Peso líquido",
        //   key: "pesoLiquido",
        //   sortable: true,
        // },
        // {
        //   label: "Cidade origem",
        //   key: "municipioOrigemId",
        //   sortable: true,
        // },
        // {
        //   label: "Cidade destino",
        //   key: "municipioDestinoId",
        //   sortable: true,
        // },
        // {
        //   label: "UF origem",
        //   key: "ufOrigemId",
        //   sortable: true,
        // },
        // {
        //   label: "Uf destino",
        //   key: "ufDestinoId",
        //   sortable: true,
        // },
        // {
        //   label: "Natureza de operação",
        //   key: "naturezaOperacao",
        //   sortable: true,
        // },
        // {
        //   label: "Previsão de entrega",
        //   key: "dataPrevisaoEntrega",
        //   sortable: true,
        // },
        // {
        //   label: "Data de coleta",
        //   key: "dataColeta",
        //   sortable: true,
        // },
        // {
        //   label: "Data de agendamento",
        //   key: "dataAgendamento",
        //   sortable: true,
        // },
        // {
        //   label: "Dias em atraso",
        //   key: "diasEmAtraso",
        //   sortable: true,
        // },
        // {
        //   label: "Situação da entrega",
        //   key: "situacaoEntrega",
        //   sortable: true,
        // },
        // {
        //   label: "Data última ocorrência",
        //   key: "dataUltimaOcorrencia",
        //   sortable: true,
        // },
        // {
        //   label: "Última ocorrência",
        //   key: "ultimaOcorrencia.ocorrenciaProceda.descricao",
        //   sortable: true,
        // },
      ],
      itemsTabelaProceda: [],
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      tableIsBusy: false,
      tableRowCount: 0,
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    myProvider(ctx) {
      this.tableIsBusy = true;
      return this.$api
        .get("/entrega/" + ctx.currentPage + "/" + ctx.perPage)
        .then((data) => {
          const items = data.data.items;
          this.tableIsBusy = false;
          this.tableRowCount = data.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
  },
};
</script>


  <style scoped>
table tr {
  white-space: normal;
}
/* table tr {
    white-space: nowrap;
  } */
/* #div-ocorrencias {
  max-width: 1550px;
} */
</style>

